import { ORIENTATION_ROW, TIMELINE_VIEW } from "../constants/identifiers";

export const MOBILE_LANDSCAPE_VIEW_ID = "primaryMobileLandscapeView";

let byId = {};

byId[MOBILE_LANDSCAPE_VIEW_ID] = {
  viewId: MOBILE_LANDSCAPE_VIEW_ID,
  viewType: TIMELINE_VIEW,
  timelineOptions: {},
  relationshipOptions: {},
  spreadsheetOptions: {},
  outlineOptions: {},
  subwayOptions: {},
  narrativeOptions: {},
  mindmapOptions: {},
  size: { width: 700, height: 150 }
};

export default {
  byId,
  layout: {
    orientation: ORIENTATION_ROW,
    children: [MOBILE_LANDSCAPE_VIEW_ID]
  },
  activeView: MOBILE_LANDSCAPE_VIEW_ID
};
